import React, { useState, useEffect } from 'react';
import { createAPIEndpoint, ENDPIONTS } from "../../api";
import { List, ListItem, ListItemText, Paper, InputBase, IconButton, makeStyles, ListItemSecondaryAction } from '@material-ui/core';
import SearchTwoToneIcon from '@material-ui/icons/SearchTwoTone';

import RuleFolderIcon from '@mui/icons-material/RuleFolder';

const useStyles = makeStyles(theme => ({
    adornmentText: {
        '& .MuiTypography-root': {
            color: '#f3b33d',
            fontWeight: 'bolder',
            fontSize: '1.5em'
        }
    },
    searchPaper: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
    },
    searchInput: {
        marginLeft: theme.spacing(1.5),
        flex: 1,
    },
    listRoot: {
        marginTop: theme.spacing(1),
        maxHeight: 450,
        overflow: 'auto',
        '& li:hover': {
            cursor: 'pointer',
            backgroundColor: '#E3E3E3'
        },
        '& li:hover .MuiButtonBase-root': {
            display: 'block',
            color: '#000',
        },
        '& .MuiButtonBase-root': {
            display: 'none'
        },
        '& .MuiButtonBase-root:hover': {
            backgroundColor: 'transparent'
        }
    }
}))

export default function CancelarReciboSearch(props) {

    const { values, setValues } = props;
    let orderedFoodItems = values.orderDetails;

    const [foodItems, setFoodItems] = useState([]);
    const [searchList, setSearchList] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const classes = useStyles();

    //let idalumno = sessionStorage.getItem('_CARRITO_IDALUMNO');
    let idalumno = props.alumnoid;
    let cicloseleccionado = values.customerId;

    //console.log("--------->>>>" + idalumno);

    //console.log("CICLO ESCOLAR --------->>>>" + cicloseleccionado);

    //console.log("JAVIER --------->>>>" + orderedFoodItems);

    const h = "";

    useEffect(() => {

        var parametros = "?Idalumno=" + idalumno + "&Idcicloescolar=" + cicloseleccionado;

        createAPIEndpoint(ENDPIONTS.HISTORIAL_RECIBOS).fetchVoucher(parametros)
            .then(res => {
                setFoodItems(res.data);
                setSearchList(res.data);
            })
            .catch(err => console.log(err))

    }, [idalumno, cicloseleccionado])


    useEffect(() => {
        let x = [...foodItems];
        x = x.filter(y => {
            return y.orderNumber.toLowerCase().includes(searchKey.toLocaleLowerCase())
                
        });
        setSearchList(x);
    }, [searchKey, orderedFoodItems])

    const addFoodItem = foodItem => {


//      console.log("SELECCION " + foodItem.orderMasterId);
//      console.log(JSON.stringify(values.orderDetails));
        

        setValues({
            ...values,
            reciboseleccionado: foodItem.orderMasterId
        })

    }

    return (
        <>
            <Paper className={classes.searchPaper}>
                <InputBase
                    className={classes.searchInput}
                    value={searchKey}
                    onChange={e => setSearchKey(e.target.value)}
                    placeholder="Buscar número de recibo" />
                <IconButton>
                    <SearchTwoToneIcon />
                </IconButton>
            </Paper>
            <List className={classes.listRoot}>
                {
                    searchList.map((item, idx) => (
                        <ListItem
                            key={idx}
                            onClick={e => addFoodItem(item)}>
                            <ListItemText
                                primary={'# Recibo: ' + item.orderNumber + ' - Id Sistema:' + item.orderMasterId +'' + ((' / Fecha: ' + item.fecha))}
                                secondaryTypographyProps={{
                                    style: {
                                        fontWeight: '500',
                                        fontSize: 'x-small',
                                        color: '#b30000'
                                    }
                                }}
                                secondary={'Tipo pago: ' + item.pmethod + ' / Cobro: $' + item.gtotal + ' / Usuario: ' + item.alias + ' / Factura: ' + item.factura + ' / Cerrado: ' + (item.cerrarcorte ? 'SI' : 'NO')}
                            />
                            <ListItemSecondaryAction>
                                <IconButton onClick={e => addFoodItem(item)}>
                                    <RuleFolderIcon  />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))
                }
            </List>
        </>
    )
}
